import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { empty } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-catalogs-catalog-devices-mcatalog-card',
  templateUrl: './catalogs-catalog-devices-mcatalog-card.component.html',
  styleUrls: ['./catalogs-catalog-devices-mcatalog-card.component.scss']
})
export class CatalogsCatalogDevicesMCatalogCardComponent implements OnInit, OnDestroy {

  @Input() catalog: CatalogBasic;
  @Input() mCatalogDevices;
  selectedDevices;
  updateCatalogDevicesMCatalogSubscription: Subscription;
  getCatalogDevicesSubscription: Subscription;

  constructor(private catalogsService: CatalogsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  public duallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDevices = aux;
      this.updateCatalogDevices(this.getDevicesInternalIds(this.selectedDevices));
    }
  }

  public updateCatalogDevices(devicesInternalIds) {
    this.updateCatalogDevicesMCatalogSubscription = this.catalogsService.updateCatalogDevicesMCatalog(this.catalog.InternalId, devicesInternalIds).pipe(
      tap(o => this.catalogsService.refreshCatalog()),
      tap(o => this.snackbarService.open('catalogs-page.snackbar messages.update catalog success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private getDevicesInternalIds(devices) {
    if (devices) {
      return devices.map(d => d.InternalId);
    }
    return [];
  }

  ngOnDestroy() {
    if (this.updateCatalogDevicesMCatalogSubscription) { this.updateCatalogDevicesMCatalogSubscription.unsubscribe(); }
    if (this.getCatalogDevicesSubscription) { this.getCatalogDevicesSubscription.unsubscribe(); }
  }

}
